/*
  The custom-name logic should only be enabled in template `custom-name`.
  The below `if` helps us reduce the impact the whole site.

  Tested url: http://127.0.0.1:9292/products/lot-de-pots-de-peinture-supplementaire
*/
window.addEventListener("DOMContentLoaded", function () {
  var createAutocompleteWidgetForModelName = function (fa_$) {
    var createAutocompleteWidget = (val_list) => {
      /*
          the autocomplete function takes two arguments,
          the text field element and an array of possible autocompleted values:
          */
      var currentFocus;

      let originalInput = fa_$("#model-names")
        .attr("autocomplete", "off")
        .hide();

      let wrappedSelect = fa_$("<span>")
        .addClass("autocomplete-select")
        .insertAfter(originalInput);

      let alert = fa_$("<div></div>")
        .addClass("autocomplete-error")
        .append("Please enter a valid model name")
        .insertAfter(wrappedSelect)
        .hide();

      let wrappedSelectInput = fa_$("<input>")
        .attr("id", "1")
        .attr("autocomplete", "off")
        .appendTo(wrappedSelect);

      let acList = fa_$("<div></div>")
        .attr("id", getACListID(1))
        .addClass("autocomplete-items")
        .hide()
        .appendTo(wrappedSelect);

      var wasOpen = false;

      fa_$("<a>")
        .attr("tabIndex", -1)
        .appendTo(wrappedSelect)
        .on("mousedown", function () {
          wasOpen = acList.is(":visible");
        })
        .on("click", function () {
          wrappedSelectInput.trigger("focus");

          // Close if already visible
          if (wasOpen) {
            return;
          }

          // Mimic a input event to trigger the dropdown list
          wrappedSelectInput.trigger("input");
        });

      // <button type="submit" name="add" id="AddToCart-product-template" class="btn product-form__cart-submit">
      // the submit action uses `ajax` which bypass `required` check. We need add our own logic to check if the model name is empty
      fa_$("button[type=submit].product-form__cart-submit").on("click", (e) => {
        let val = wrappedSelectInput.val();

        if (!val) {
          e.preventDefault();
          alert.show();
          return false;
        }

        // Always trim the tailing whitespaces
        val = val.trim();
        if (val_list.indexOf(val) < 0) {
          e.preventDefault();
          alert.show();
          return false;
        }

        // We set the original input at the last step right before submit
        originalInput.val(val);
      });

      function addActive(acItems) {
        /*
            a function to classify an item as "active":
            */
        if (!acItems) return false;

        // start by removing the "active" class on all items:
        removeActive(acItems);

        if (currentFocus >= acItems.length) {
          currentFocus = 0;
        } else if (currentFocus < 0) {
          currentFocus = acItems.length - 1;
        }

        // add class "autocomplete-active":
        let currentItem = acItems.eq(currentFocus);
        currentItem.addClass("autocomplete-active");

        let newScrollTop =
          (currentFocus * acList.get(0).scrollHeight) / acItems.length;
        acList.animate({ scrollTop: newScrollTop }, 100);
      }

      function removeActive(acItems) {
        /*
            a function to remove the "active" class from all autocomplete items:
            */
        acItems.removeClass("autocomplete-active");
      }

      function closeAllLists(target) {
        /*
            close all autocomplete lists in the document,
            except the one passed as an argument:
            */

        acList.children().remove();
        acList.hide();
        currentFocus = -1;
      }

      function getACListID(id) {
        return "autocomplete-list-" + id;
      }

      function onClickItem(e) {
        alert.hide();
        // read here https://stackoverflow.com/questions/18859601/click-event-not-bubbling-when-image-clicked
        // e.currentTarget is `div`
        // e.target is the actual clicked child element
        let sel = fa_$(e.currentTarget)
          .children("input[type='hidden']:first")
          .val();
        if (!sel) {
          console.debug(e.currentTarget, sel);
        } else {
          // Trim the tailing whitespaces
          wrappedSelectInput.val(sel.trim());
          // close the list of autocompleted values, (or any other open lists of autocompleted values:
          closeAllLists();
        }
      }

      function onInput(e) {
        let val = fa_$(this).val().toLowerCase();

        // close any already open lists of autocompleted values
        closeAllLists();

        if (!val) {
          fa_$.each(val_list, (index, item) => {
            acList.append(
              fa_$("<div></div>")
                .append(item)
                .append(fa_$("<input type='hidden'>").val(item))
                .on("click", onClickItem)
            );
          });
        } else {
          // Trim the tailing whitespaces
          val = val.trim();

          fa_$.each(val_list, (index, item) => {
            if (
              item.length >= val.length &&
              item.toLowerCase().startsWith(val)
            ) {
              // make the matching letters bold
              acList.append(
                fa_$("<div></div>")
                  .append("<strong>" + item.substr(0, val.length) + "</strong>")
                  .append(item.substr(val.length))
                  .append(fa_$("<input type='hidden'>").val(item))
                  .on("click", onClickItem)
              );
            }
          });
        }

        // We only display the list if there are some match
        if (acList.children().length > 0) {
          acList.show();
        }
      }

      function onKeyDown(e) {
        let acItems = acList.children("div");

        if (e.keyCode == 40) {
          // If the arrow DOWN key is pressed, increase the currentFocus variable:
          currentFocus++;

          // and and make the current item more visible:
          addActive(acItems);
        } else if (e.keyCode == 38) {
          // If the arrow UP key is pressed, decrease the currentFocus variable:
          currentFocus--;

          // and and make the current item more visible:
          addActive(acItems);
        } else if (e.keyCode == 13) {
          // If the ENTER key is pressed, prevent the form from being submitted
          e.preventDefault();

          if (currentFocus > -1) {
            // and simulate a click on the "active" item:
            if (acItems) {
              acItems.eq(currentFocus).click();
            }
          }
        }
      }

      var selected = originalInput.children(":selected"),
        value = selected.val() ? selected.text() : "";

      wrappedSelectInput
        .val(value)
        .on("input", fa_$.debounce(250, onInput))
        .on("keydown", onKeyDown);

      /* execute a function when someone clicks in the document: */
      fa_$(document).on("click", (e) => {
        closeAllLists(e.target);
      });
    };

    console.debug("Start to fetch the sku list from " + faConfig.sku_list_url);

    fa_$.ajax({
      url: faConfig.sku_list_url,
      fail: function(xhr, textStatus, errorThrown) {
        console.error('Activate autocomplete model name selection failed for', xhr);
      },
      success: function (data, textStatus) {
        // data is "var sku_list=[...]"
        // We need eval to initialize sku_list
        eval(data);
        // verify sku_list 
        console.debug(sku_list);

        fa_$(function () {
          let ddlModels = fa_$("select#model-names");
          ddlModels.empty();

          fa_$.each(sku_list, function (i) {
            ddlModels.append(
              fa_$("<option></option>")
                .attr("value", sku_list[i])
                .text(sku_list[i])
            );
          });

          ddlModels.val(sku_list[0]).change();

          createAutocompleteWidget(sku_list);

          console.debug(
            "Activate autocomplete model name selection for custom name page feature"
          );
        });
      },
    });
  };

  faLoadjQueryThenRun((fa_$) => {
    console.log(
      "This site is using jQuery version: " +
        fa_$.fn.jquery +
        " (figured-art.custom-name.js)"
    );

    createAutocompleteWidgetForModelName(fa_$);
  });
});
